import { EmptyProps } from "@/Common/Components/BaseReactComponent";
import { NotesToolTipControl } from "@/Common/Components/Modals/NotesToolTipControl";
import { LabTabViews } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LabsInboxView } from "@/Labs/Components/LabsInBoxView";
import { LabView } from "@/Labs/Components/LabView";
import { ILabModel } from "@/Labs/Models/UI/ILabModel";
import { ILabsActionInboxModel } from "@/Labs/Models/UI/ILabsActionInboxModel";
import { ILabGraphsModel } from "@/Labs/Models/UI/ILabsGraphModel";
import { ILabsInboxModel } from "@/Labs/Models/UI/ILabsInboxModel";
import { ILabsTabModel } from "@/Labs/Models/UI/ILabsTabModel";
import { ISideNoteModel } from "@/Labs/Models/UI/ISideNoteModel";
import { LabActionDetailsPopup } from "./LabActionDetailsPopup";
import { LabActionDetailsTooltipControl } from "./LabActionDetailsTooltipControl";
import { LabActionNotesTooltipControl } from "./LabActionNotesTooltipControl";
import { LabGraphSearchComponent } from "./LabGraphSearchComponent";
import { LabGraphView } from "./LabGraphView";
import { LabsActionInboxView } from "./LabsActionInboxView";
import { LabTreeControl } from "./LabTreeControl";

class LabsTabState {
    public Model: ILabsTabModel;
    public LabsInboxModel: ILabsInboxModel;
    public LabModel: ILabModel;
    public SiteNoteModel: ISideNoteModel;
    public LabsActionInboxModel: ILabsActionInboxModel;
    public LabGraphModel: ILabGraphsModel;
}

class LabsTab extends React.Component<EmptyProps, LabsTabState> {
    private changeListenerMethodId: string;
    private ramqChangeListenerMethodId: string;

    constructor(props: EmptyProps) {
        super(props);

        labsStore.SaveState(); // just in case we come from PatientLabsTab (componentWillUnmount of PatientLabsTab is called after mount here)
        labsStore.ReturnStateToMainTab();
        this.state = this.getInitialState();
    }

    public render(): JSX.Element {
        return (
            <div className="sub-container">
                {this.renderLeftSideTreeMenuOrNot(this.state.Model.get("CurrentView"))}

                {this.state.Model.get("CurrentView") === LabTabViews.Graph && (
                    <div className="left-nav-menu lab-graphs" style={{ width: "200px" }}>
                        <div className="fxheight">
                            <div>
                                <a onClick={() => { LocalEvent.Dispatch(LocalOperations.LabsUI.Graphs_BackToResults); }}>  {"<< " + cacheStore.GetString("BackToResultLabel")}</a>
                            </div>
                            <LabGraphSearchComponent LabModel={this.state.LabModel} GraphModel={this.state.LabGraphModel} />
                        </div>
                    </div>
                )}

                {this.state.Model.get("CurrentView") == LabTabViews.Inbox && (
                    <LabsInboxView Model={this.state.LabsInboxModel} />
                )}
                {this.state.Model.get("CurrentView") == LabTabViews.Lab && this.state.LabModel != null && (
                    <LabView Model={this.state.LabModel} InboxModel={this.state.LabsInboxModel} SideNoteModel={this.state.SiteNoteModel} LabTabModel={this.state.Model} />
                )}
                {this.state.Model.get("CurrentView") == LabTabViews.ActionsInbox && (
                    <LabsActionInboxView Model={this.state.LabsActionInboxModel} />
                )}
                {this.state.Model.get("CurrentView") == LabTabViews.Graph && (
                    <LabGraphView LabModel={this.state.LabModel} GraphModel={this.state.LabGraphModel} />
                )}

                {this.state.Model.get("NoteWindowOpen") == true && (
                    <NotesToolTipControl
                        ControlId="lab_notes_dropdown_main"
                        notes={this.state.Model.get("CurrentLabNotes").toArray()}
                        ReferenceId={this.state.Model.get("CurrentLabIDForNotes")}
                        SubReferenceId={this.state.Model.get("CurrentElementIDForNotes")}
                        Value={this.state.Model.get("CurrentLabNoteValue")}
                        EventToDispatchOnSave={LocalOperations.LabsUI.Note_Save}
                        EventToDispatchOnTextChanged={LocalOperations.LabsUI.Note_Text_Changed}
                        EventToDispatchOnDropdownClosed={LocalOperations.LabsUI.ClosePopups}
                        leftPosition={this.state.Model.get("NoteLeftPosition")}
                        topPosition={this.state.Model.get("NoteTopPosition")}
                        isManualLabEntry={this.state.Model.get("CurrentLabIsManualResult")}
                    />
                )}

                {this.state.Model.get("Action_NoteWindowOpen") == true && (
                    <LabActionNotesTooltipControl
                        ControlId="lab_actions_dropdown_main"
                        ReferenceId={this.state.Model.get("Action_CurrentLabIDForNotes")}
                        SubReferenceId={this.state.Model.get("Action_CurrentElementIDForNotes")}
                        Value={this.state.Model.get("Action_CurrentLabNoteValue")}
                        actionNursesCheckboxes={this.state.Model.get("Action_CheckboxesNurses")}
                        actionSecretaryCheckboxes={this.state.Model.get("Action_CheckboxesSecretaries")}
                        leftPosition={this.state.Model.get("Action_NoteLeftPosition")}
                        topPosition={this.state.Model.get("Action_NoteTopPosition")}
                        EventToDispatchToClosePopup={LocalOperations.LabsUI.ClosePopups}
                    />
                )}

                {this.state.Model.get("Action_DetailsWindowOpen") == true && (
                    <LabActionDetailsTooltipControl
                        ControlId="lab_actionsdetails_dropdown_main"
                        Model={this.state.Model.get("Action_DetailsModel")}
                        ReferenceId={this.state.Model.get("Action_CurrentLabIDForActionDetails")}
                        leftPosition={this.state.Model.get("Action_DetailsLeftPosition")}
                        topPosition={this.state.Model.get("Action_DetailsTopPosition")}
                        EventToDispatchToClosePopup={LocalOperations.LabsUI.ClosePopups}
                    />
                )}

                {cacheStore.ClinicSettings.EnableResultsFixes && this.state.Model.get("ResultDetailPopupOpen") === true && (
                    <LabActionDetailsPopup
                        notes={this.state.Model.get("CurrentLabNotes").toArray()}
                        noteTextValue={this.state.Model.get("CurrentLabNoteValue")}
                        detailTextValue={this.state.Model.get("CurrentLabDetailsValue")}
                        referenceId={this.state.Model.get("CurrentLabIDForNotes")}
                        subReferenceId={this.state.Model.get("CurrentElementIDForNotes")}
                        onNoteTextChange={(newText: string): void => {
                            sessionStore.dispatch(LocalOperations.LabsUI.Note_Text_Changed, {
                                value: newText
                            });
                        }}
                        onClose={(): void => sessionStore.dispatch(LocalOperations.LabsUI.ClosePopups)}
                        isManualLabEntry={this.state.Model.get("CurrentLabIsManualResult")}
                    />
                )}
            </div>
        );
    }

    public shouldComponentUpdate(nextState: LabsTabState): boolean {
        return (
            this.state.Model !== nextState.Model
            || this.state.LabsInboxModel !== nextState.LabsInboxModel
            || this.state.LabModel !== nextState.LabModel
            || this.state.SiteNoteModel !== nextState.SiteNoteModel
            || this.state.LabsActionInboxModel !== nextState.LabsActionInboxModel
            || this.state.LabGraphModel !== nextState.LabGraphModel
        );
    }

    public componentDidMount(): void {
        this.changeListenerMethodId = labsStore.AddChangeListener(this.changeListener, this, "lab-tab-listener");
        this.ramqChangeListenerMethodId = ramqStore.AddChangeListener(this.ramqChangeListener, this, "lab-tab-ramqlistener");
        labsStore.RefreshSearch();
        labsStore.LabActions.GetLabsActionsCount();

        if (cacheStore.ClinicSettings.EnableCentralizedManualLabsGrid) {
            labsStore.LabActions.UpdateNewManualLabResultCount();
        }
    }

    public componentWillUnmount(): void {
        labsStore.SaveState();
        labsStore.RemoveChangeListener(this.changeListenerMethodId);
        ramqStore.RemoveChangeListener(this.ramqChangeListenerMethodId);
    }

    public changeListener(): void {
        const newState = this.getInitialState();
        this.setState(newState);
    }

    public ramqChangeListener(): void {
        if (labsStore.LabModel) {
            const patientModel = labsStore.LabModel.get("MylePatient");
            labsStore.LabModel = labsStore.LabModel.delete("MylePatient");
            labsStore.LabModel = labsStore.LabModel.set("MylePatient", patientModel);
            labsStore.EmitChangeToListeners();
        }
    }

    private renderLeftSideTreeMenuOrNot(view: LabTabViews): JSX.Element {
        if (view !== LabTabViews.Graph) {
            return (
                <div className="left-nav-menu labs transition">
                    <div className="ws-scrollable hide-overflow">
                        <LabTreeControl IsPatientNav={false} Model={this.state.Model} NonApprovedLabCount={null} CurrentActionInbox={labsStore.LabsActionInboxModel.get("CurrentInbox")} CurrentLabInbox={labsStore.LabsInboxModel.get("CurrentInbox")} />
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="left-nav-menu labs collapsed" />
            );
        }
    }

    private getInitialState(): LabsTabState {
        const state = new LabsTabState();
        state.Model = labsStore.Model;
        state.LabsInboxModel = labsStore.LabsInboxModel;
        state.LabModel = labsStore.LabModel;
        state.SiteNoteModel = labsStore.SideNoteModel;
        state.LabsActionInboxModel = labsStore.LabsActionInboxModel;
        state.LabGraphModel = labsStore.LabGraphModel;

        return state;
    }
}

export { LabsTab, LabsTabState };
